import React from 'react';
import { StatusTip, Popover } from 'tea-component';
import { getLocale } from 'umi';
import { LANGUAGE_CN } from '@/pages/home/_config/config';

import './index.scss';
const { LoadingTip } = StatusTip;

export default function StatusLoading(props: any) {
  const { className = '' } = props;
  const loadingText = getLocale() === LANGUAGE_CN ? '加载中...' : 'Loading...';
  return (
    <Popover
      visible={true}
      overlay={
        <div className="db-full-loading-mask">
          <LoadingTip loadingText={loadingText} {...props} className={`db-full-loading ${className}`} />
        </div>
      }
    />
  );
}
